// extracted by mini-css-extract-plugin
module.exports = {"text":"text-3zQ3cZD4"};